import React from "react";
import styles from "../../common/archive/ArchiveHeader.module.scss";

type Props = {
  sort: string;
  handleSort: (sort: string) => void;
};
const ProjectListSort: React.FC<Props> = ({ sort, handleSort }) => {
  return (
    <>
      <div className={styles["search-count"]}>
        <span>表示順：</span>
        <select
          value={sort === "end_date" ? "end_date" : "_id"}
          onChange={(e) => {
            handleSort(e.target.value);
          }}
          className={sort === "end_date" ? styles["end"] : styles["new"]}
        >
          <option value="_id">新着順</option>
          <option value="end_date">終了日が近い順</option>
        </select>
      </div>
    </>
  );
};

export default ProjectListSort;
